"use strict";
jQuery('.gform_next_button').click(function () {
    var button = jQuery(this);
    button.attr('disabled', true).val('Processing...');
});
